import { useQuery } from '@tanstack/react-query';
import { CampaignsService } from '../services';
import { campaignsKeys } from '../queryKeys';
import { READ_ONLY_QUERY_OPTIONS } from '../queryConfig';

/**
 * One office's promo history for its Discounts & Promo Codes tab. Invalidated
 * by useApplyOfficePromoCode and useRemoveOfficePromoCode, which is how an
 * applied or removed code reaches the table. Disabled until the profile has
 * resolved the office id, which callers must treat as "still loading" rather
 * than "no history" — the two look identical on `history`.
 */
export const useOfficeDiscountHistory = (officeId) => {
  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey: campaignsKeys.officeDiscountHistory(officeId),
    queryFn: () => CampaignsService.getOfficeDiscountHistory(officeId),
    enabled: Boolean(officeId),
    ...READ_ONLY_QUERY_OPTIONS,
  });

  return {
    history: data ?? [],
    isPending,
    isFetching,
    isError,
    error,
  };
};
